import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { KTIcon } from '../../../../_theme/helpers/components/KTIcon';

interface ConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  deleteMessage?: string;
  popupLoader?:boolean;
  actionButtonText?: string;
  modalTitle?: string;
  confirmClass?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  deleteMessage = '',
  popupLoader=false,
  actionButtonText="Delete",
  modalTitle="Confirmation",
  confirmClass="danger"
}) => {
  return (
    <Modal
        show={show}
        onHide={onClose}
        dialogClassName='modal-dialog modal-dialog-centered'
        backdrop="static" keyboard={false}
      >
        <div className='modal-header pb-5'>
            <h2>{modalTitle}</h2>
            <button className='btn btn-sm btn-icon btn-active-color-primary' onClick={onClose} aria-label="Close">
                <KTIcon className='fs-1' iconName='cross' />
            </button>        
        </div>
        <div className='modal-body text-center'>
            <p className='fs-5'>{deleteMessage}</p>
        </div>
        <Modal.Footer className='justify-content-center'>
            <Button variant='secondary' onClick={onClose} disabled={popupLoader}>
                Cancel
            </Button>
            <Button
                variant={confirmClass}
                onClick={onConfirm}
                disabled={popupLoader}
            >
                {actionButtonText} {popupLoader ? <i className="fa-solid fa-spinner fa-spin pe-0"></i> : ""}
            </Button>
        </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
